export const transactionDetailsConfig = {
    defaultExpanded: ['5ATT'],
    flatten: true,
    targetName: '_section'
}